import { defineComponent } from 'vue'
import { mapActions, mapGetters } from 'vuex'
import { OrgBaseActions, OrgBaseGetters } from '~/store/control-panel/base'

export default defineComponent({
  name: 'ControlPanelBaseMixin',

  data() {
    return {
      CONTROL_PANELS: [
        {
          icon: 'users',
          title: ['User management'],
          description:
            'Manage all users across teams of this DeepSource enterprise instance installation.',
          to: '/control-panel/user-management',
          subroutes: [
            {
              icon: 'users',
              title: ['User management', 'All users'],
              to: '/control-panel/user-management',
              navTo: '/control-panel/user-management/users'
            },
            {
              icon: 'building',
              title: ['User management', 'Groups'],
              to: '/control-panel/user-management/groups'
            },
            {
              icon: 'envelope-add',
              title: ['User management', 'Invitations'],
              to: '/control-panel/user-management/invites'
            }
          ]
        },
        {
          icon: 'file-landscape',
          title: ['License'],
          description:
            'Manage and monitor license usage across this DeepSource enterprise installation.',
          to: '/control-panel/license',
          subroutes: [
            {
              icon: 'file-landscape',
              title: ['License', 'License overview'],
              to: '/control-panel/license'
            }
          ]
        },
        {
          icon: 'hard-hat',
          title: ['Installation Management Console'],
          description: 'Manage your DeepSource Enterprise installation.'
        },
        {
          icon: 'headphones-alt',
          title: ['Enterprise Help Center'],
          description:
            'Reach out to the DeepSource team to resolve issues or ask questions on a priority basis.',
          href: 'https://docs.deepsource.com/docs'
        }
      ],
      secondaryMenuList: ['Enterprise Help Center']
    }
  },

  computed: {
    ...mapGetters('control-panel/base', {
      managementConsoleUrl: OrgBaseGetters.GET_MANAGEMENT_URL,
      orgInfo: OrgBaseGetters.ORG_BASE_DATA
    }),
    isSubroute(): boolean {
      return (this.$route.path.slice(0, -1).match(/\//g)?.length ?? 0) > 2
    },
    parentRoute(): string {
      if (this.isSubroute) return this.$route.path.split('/').slice(0, 3).join('/')
      return this.$route.path
    },
    subRoute(): string {
      return this.$route.path.split('/').slice(0, 4).join('/')
    }
  },

  methods: {
    ...mapActions('control-panel/base', {
      getOrgBaseData: OrgBaseActions.FETCH_ORG_BASE_DATA
    }),
    getPageTitle(titleArray: string[]): string {
      return titleArray.slice(-1)[0] ?? ''
    }
  }
})
